import React from 'react'
import { MENU } from '@/config/menu.config'
import { cn } from '@/lib/utils'

interface MegaMenuProps {
  onMouseEnter: () => void
  onMouseLeave: () => void
}

export function MegaMenu({ onMouseEnter, onMouseLeave }: MegaMenuProps) {
  const servicesItem = MENU.find(item => item.label === 'Services')
  
  if (!servicesItem?.children) return null

  const groups = servicesItem.children.filter(child => 'group' in child && 'items' in child)

  return (
    <div
      className="fixed inset-x-0 top-20 z-50 flex justify-center animate-in fade-in slide-in-from-top-2 duration-200"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="w-[1800px] max-w-[95vw]">
      <div 
        className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl"
      >
        <div className="p-8">
          <div className="grid grid-cols-3 gap-8">
            {groups.map((group) => (
              <div
                key={group.group}
                className={cn(
                  "space-y-4",
                  group.group === "AI & Data Solutions" && "mb-6"
                )}
              >
                <div className="border-b border-border pb-3 mb-4">
                  <h3 className="text-sm font-semibold text-primary uppercase tracking-wide whitespace-nowrap">
                    {group.group}
                  </h3>
                </div>
                <ul className="space-y-3">
                  {group.items?.map((item) => (
                    <li key={item.label}>
                      <a
                        href={item.href}
                        className={cn(
                          "flex items-start space-x-3 p-2 rounded-lg transition-all duration-200",
                          "hover:bg-muted/50 hover:text-primary hover:translate-x-1 group",
                          "min-h-[3rem] leading-snug"
                        )}
                      >
                        {item.icon && (
                          <item.icon className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0 mt-0.5" />
                        )}
                        <div>
                          <div className="text-sm font-medium">{item.label}</div>
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
                {group.group === "AI & Data Solutions" && <div className="h-6" />}
              </div>
            ))}
          </div>
          
          {/* Bottom CTA */}
          <div 
            className="mt-8 pt-6 border-t border-border"
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-sm font-semibold">Need custom solutions?</h4>
                <p className="text-xs text-muted-foreground mt-1">Let's discuss your specific requirements</p>
              </div>
              <a
                href="/contact"
                className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 hover:scale-105 active:scale-95 transition-all"
              >
                Get in Touch
              </a>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}
